import { useContext } from "react";

import useErrorHandler from "@beeldit/core/errors/useErrorHandler";
import store from "@beeldit/core/services/store";
import { UnpayActionContext } from "./UnpayActionContext";

function useStore() {
  const { element, setBackendFormErrors } = useContext(UnpayActionContext);
  const errorHandler = useErrorHandler();
  return (onSuccess: any) => {
    store("categories/enrollment/unpay", element)
      .then((response: any) => {
        onSuccess(response.data);
      })
      .catch((error: any) => {
        console.error("Error fetching data:", error);
        errorHandler(error, setBackendFormErrors);
      });
  };
}

export default useStore;
